import { createContext } from 'react'

export const AWSRumContext = createContext(null)
